module.exports = __webpack_public_path__ + "static/media/cerrar.540ddeab.svg";